<template>
	<div>
		<el-container>
			<el-container>

				<el-header>
					<el-form :inline="true">

						<el-form-item>
							<el-date-picker
							  v-model="value1"
							  type="daterange"
							  range-separator="至"
							  start-placeholder="开始日期"
							  end-placeholder="结束日期"
							  format="yyyy 年 MM 月 dd 日"
							  value-format="yyyy-MM-dd"
							>
<!--							  format="yyyy-MM-dd"-->
							</el-date-picker>
						</el-form-item>

						<el-form-item>
							<el-button @click="getMachineList">搜索</el-button>
						</el-form-item>

					</el-form>
				</el-header>

				<el-main>
					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  style="margin-top: -20px;"
					  :height="tableHeight"
					  :row-style="{height: '0px'}"
					  :cell-style="{padding: '2px'}"
					  :header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
					  border
					  stripe
					  @selection-change="handleSelectionChange">

						<el-table-column
						  type="selection"
						>
						</el-table-column>

						<el-table-column
						  prop="machineNum"
						  label="设备编号"
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  prop="machineIp"
						  label="IP地址"
						  align="center"
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  label="预警值状态"
						  align="center"
						  show-overflow-tooltip>
							<template slot-scope="scope">
								<el-tag
								  :type="scope.row.alarmFlag === 0 ? 'success' : 'danger'"
								  disable-transitions>{{
										{
											0: "正常",
											1: "温度告警",
											2: "湿度告警",
											3: "温度和湿度同时告警",
										}[scope.row.alarmFlag]
									}}
								</el-tag>
							</template>
						</el-table-column>

						<el-table-column
						  label="当前温度（℃）"
						  align="center"
						  show-overflow-tooltip>
							<template slot-scope="scope">
								{{ scope.row.temperature / 10 }}
							</template>
						</el-table-column>

						<el-table-column
						  label="当前湿度（%）"
						  align="center"
						  show-overflow-tooltip>
							<template slot-scope="scope">
								{{ scope.row.humidity / 10 }}
							</template>
						</el-table-column>

						<el-table-column
						  prop="machineDate"
						  label="读取时间"
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  prop="status"
						  label="是否处理"
						  align="center"
						  show-overflow-tooltip>
						</el-table-column>

						<el-table-column
						  prop="icon"
						  fixed="right"
						  label="操作">
							<template slot-scope="scope">
								<el-button type="text" @click="editHandle(scope.row.id)">处理</el-button>
							</template>
						</el-table-column>
					</el-table>

					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[10, 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

	</div>
</template>

<script>
export default {
	name: "AlarmList",
	data() {
		return {
			loading: true,

			searchForm: {},
			value1: [],
			delBtlStatu: true,

			total: 0,
			size: 10,
			current: 1,

			dialogVisible: false,
			editForm: {},
			mediumDialogVisible: false,
			mediumForm: {},

			tableData: [],
			mediumData: [],

			selectedIdentityId: '',
			machineTypeList: [],
			interfaceList: [],
			gatewayList: [],

			editFormRules: {
				machineNum: [
					{required: true, message: '请输入设备编号', trigger: 'blur'}
				],
				shortName: [
					{required: true, message: '请输入设备别名', trigger: 'blur'}
				],
				machineTypeId: [
					{required: true, message: '请选择设备类型', trigger: 'blur'}
				],
				interfaceId: [
					{required: true, message: '请选择接口协议', trigger: 'blur'}
				],
				locationId: [
					{required: true, message: '请选择安装位置', trigger: 'blur'}
				]
			},

			multipleSelection: [],

			permDialogVisible: false,
			permForm: {},
			defaultProps: {
				children: 'children',
				label: 'machineNum'
			},
			treeSelectLocationId: 0,
			selectedMachineInfo: '',
			bindMachineId: '',
			newMediumVal: '',
			newMediumType: '',
			newMediumEndTime: '',
			// permTreeData: []
			statusFlagOptions: [{
				value: '9',
				label: '全部'
			}, {
				value: '1',
				label: '正常'
			}, {
				value: '0',
				label: '禁用'
			}],
			statusFlagValue: '1',
			machineTypeIds: [],
			gatewayIds: [],
		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	created() {
		this.value1=[this.getPastDate(1), this.getPastDate(0)];
		this.getMachineList()
	},
	methods: {
		handleSelectionChange(val) {
			console.log("勾选")
			console.log(val)
			this.multipleSelection = val;

			this.delBtlStatu = val.length == 0
		},

		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.size = val
			this.getMachineList()
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.current = val
			this.getMachineList()
		},
		getMachineList() {
			console.log("machineTypeIds=", this.machineTypeIds);
			console.log("gatewayIds=", this.gatewayIds);
			console.log(this.value1);
			this.loading = true;
			this.$axios.get("/cabinet/alarmlist", {
				params: {
					// machineTypeIds: 20,
					// machineNum: this.searchForm.machineNum,
					// shortName: this.searchForm.shortName,
					// // machineTypeIds: this.machineTypeIds + "",
					// ipAddress: this.searchForm.ipAddress,
					// gatewayIds: this.gatewayIds + "",
					// statusFlag: this.statusFlagValue,
					// isOnline: this.searchForm.isOnline,
					machineId: 0,
					beginDate: this.value1[0],
					endDate: this.value1[1],
					current: this.current,
					size: this.size
				}
			}).then(res => {
				this.tableData = res.data.data.records
				this.size = res.data.data.size
				this.current = res.data.data.current
				this.total = res.data.data.total
				this.loading = false;
			})
		},
		editHandle(id) {
			this.$axios.get('/iot/machine/info/' + id).then(res => {
				this.editForm = res.data.data

				this.dialogVisible = true
			})
		},
		getPastDate(n) {
			const today = new Date();
			const pastDate = new Date(today);
			pastDate.setDate(today.getDate() - n);

			const year = pastDate.getFullYear();
			const month = String(pastDate.getMonth() + 1).padStart(2, '0');
			const day = String(pastDate.getDate()).padStart(2, '0');

			return `${year}-${month}-${day}`;
		}
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
</style>